import { useEffect, useState } from 'react';

import { Button } from '@american-autonomy/ag-ui';

import Grid from 'components/Grid';
import VectorIcon from 'components/icons/VectorIcon';
import CaptionText from 'components/text/CaptionText';

import useTranslation from './hooks/useTranslation';

import { COLLAPSE_DELAY, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const AddButton: FunctionComponent<Props> = ({ onClick, testId = TEST_ID }) => {
    const { CAPTION_TEXT } = useTranslation();
    const [isCollapsed, setIsCollapsed] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setIsCollapsed(true), COLLAPSE_DELAY);

        return () => clearTimeout(timer);
    }, []);

    const collapsedClass = isCollapsed ? styles.collapsed : '';

    return (
        <Grid className={`${collapsedClass} ${styles.addButton}`} testId={testId}>
            <VectorIcon className={styles.vectorIcon} />

            <CaptionText className={styles.captionText} text={CAPTION_TEXT} />

            <Button className={styles.button} onClick={onClick} text='+' />
        </Grid>
    );
};

export default AddButton;
